import { publishSticky } from '@wh/message-bus';
import { getValueFromContent } from '../../utils';

export const productMenuPlugin = {
  beforeRender({ header, params, content }) {
    const parsedItems = getValueFromContent(params.items, content);
    if (process.env.RUNTIME === 'browser') {
      parsedItems.forEach((item) => {
        const { hostname, pathname, protocol } = window.location;
        const itemUrl = item.url.replace(/\/*$/, '');
        if (`${protocol}//${hostname}${pathname}`.includes(itemUrl)) {
          publishSticky('wh.common.command.ui.header.product.select', {
            id: `product-menu-item-${getValueFromContent(item.label, content)}`,
          });
        }
      });
    }

    Array.isArray(parsedItems) &&
      (header.productNav = {
        type: '@sitebase/product-menu',
        data: {
          id: 'hrs-product-nav',
        },
        children: parsedItems.map((item) => ({
          type: '@sitebase/product-menu-item',
          data: {
            label: item.label,
            id: `product-menu-item-${item.label}`,
            link: {
              url: item.url,
            },
            redirectToProduct: params.redirectToProduct,
          },
        })),
      });
  },
};
